<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  data () {
    return {
      requiredInputs: {}
    }
  },

  methods: {
    /**
     * Prepares children that are contained in this input
     * @param {Array} children
     */
    prepareChildren (children) {
      for (let c of children) {
        if (!this.requiredInputs[c.inputName]) {
          this.addChildToRequired(c)
        }
      }
    },

    /**
     * Adds a child to it's required object
     * @param {Object} child
     */
    addChildToRequired (child) {
      if (child.hasConstraints) {
        let optional = child.constraints.optional
        optional = (!optional) ? false : optional

        let constraint = {
          met: false,
          optional
        }

        this.$set(this.requiredInputs, child.inputName, constraint)
      }
    },

    /**
     * Children parameter is for unit tests.
     * @deprecated
     */
    updateChildren (children = null) {
      children = children || this.getChildren()
      let requirements = Object.assign({}, this.requiredInputs)
      this.prepareChildren(children)
      requirements = Object.assign({}, this.requiredInputs, requirements)
      this.$set(this, 'requiredInputs', requirements)
    },

    /**
     * Updates child's validity; adds it if needed
     * @param {String} inputName
     * @param {Boolean} isValid
     */
    updateValidity (inputName, isValid) {
      // Check if this child is not in the object
      if (!this.requiredInputs[inputName]) {
        let child = this.hasConstraints(inputName)
        if (child) {
          this.addChildToRequired(child)
        } else {
          // Not interested in this component...
          return
        }
      }

      this.$set(this.requiredInputs[inputName], 'met', isValid)
      this.$emit('updateValidity', {
        valid: this.inputsValid
      })
    },

    /**
     * Tells if this element has constraints
     * @param {String} inputName
     */
    hasConstraints (inputName) {
      let child = this.getChildren().filter(c => c.inputName === inputName)
      if (!child.length) {
        return false
      }

      let rtr = child.pop()
      if (!rtr.hasConstraints) return false

      return rtr
    },

    /**
     * Gives an array of all available children
     * @returns {Array}
     */
    getChildren () {
      return this.$children || []
    }
  },

  computed: {
    /**
     * Helper for inputs
     * @returns {Boolean}
     */
    isInputContainer () {
      return true
    },

    /**
     * Tells if all input requirements are met
     * @returns {Boolean}
     */
    inputsValid () {
      return Object.values(this.requiredInputs).filter(constraint => !constraint.met && !constraint.optional).length == 0
    }
  },

  beforeMount () {
    this.prepareChildren(this.getChildren())
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/standard/input/InputContainer.vue?7d800646